module.exports = __webpack_public_path__ + "static/media/logo.af5b1003.svg";